import { render, staticRenderFns } from "./EditTaskModal.vue?vue&type=template&id=25bf332a&scoped=true&"
import script from "./EditTaskModal.vue?vue&type=script&lang=js&"
export * from "./EditTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTaskModal.vue?vue&type=style&index=0&id=25bf332a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf332a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25bf332a')) {
      api.createRecord('25bf332a', component.options)
    } else {
      api.reload('25bf332a', component.options)
    }
    module.hot.accept("./EditTaskModal.vue?vue&type=template&id=25bf332a&scoped=true&", function () {
      api.rerender('25bf332a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/EditTaskModal.vue"
export default component.exports